import { selectAutoLoanTab } from 'partial/OfferDetails/actions/offerDetails.actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const useSelectAutoLoanDetails = props => {
  const { autoLoanType } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(selectAutoLoanTab(autoLoanType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoLoanType]);
};

export default useSelectAutoLoanDetails;
